import { FormattedMessage } from 'react-intl';

import InternationalisedName from '../multiLoanDashboard/dashboardComponents/InternationalisedName';
import ProductType from '../ui/productType/ProductType';

import messages from './DashboardLoanHeader.messages';
import styles from './DashboardLoanHeader.module.css';

type Props = {
    productType: string;
    productInfo: JSX.Element;
    loanDuration?: number;
    isDynamic?: boolean;
};

const DashboardLoanHeader = ({
    productType,
    productInfo,
    loanDuration,
    isDynamic
}: Props) => {
    const monthDuration = loanDuration && loanDuration + ' month';
    return (
        <div className={styles.loanHeader} data-testid="headlineText">
            <div className={styles.hello}>
                <FormattedMessage
                    {...messages.hello}
                    values={{
                        name: <InternationalisedName />
                    }}
                />
            </div>
            <div className={styles.strapline}>
                {productType && (
                    <FormattedMessage
                        {...messages.lookingAt}
                        values={{
                            productType: (
                                <ProductType
                                    productType={productType}
                                    isDynamic={isDynamic}
                                />
                            ),
                            duration: monthDuration
                        }}
                    />
                )}
                {productInfo}
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DashboardLoanHeader;
